import { render, staticRenderFns } from "./ComboboxAtores.vue?vue&type=template&id=18eef403"
import script from "./ComboboxAtores.vue?vue&type=script&lang=js"
export * from "./ComboboxAtores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports